import { v4 as uuidv4 } from 'uuid'

const CLIENT_ID = 'CLIENT_ID'
const SESSION_NAME = 'TravSessionId'
const DOMAIN = 'travelers.com'

const generateRandomNumberString = (num: number) =>
    Array(num).fill(0).map(() => Math.floor(Math.random() * 10)).join('')


const setAndReturnClientId = () => {
  const clientId = generateRandomNumberString(23)
  localStorage.setItem(CLIENT_ID, clientId)
  return clientId
}

const getClientId = () => {
  const clientId = localStorage.getItem(CLIENT_ID)
  return clientId ? clientId : setAndReturnClientId()
}

function get(key: string) {
  if (!key) return null
  return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
    encodeURIComponent(key)
      .replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) ||
    null
}

function set(
  key: string,
  value: string,
  config: { domain: string, expires?: any, path?: string, secure?: boolean }) {
  const expires = config ? config.expires : null,
    path = config ? config.path : null,
    domain = config ? config.domain : null,
    isSecure = config ? !!config.secure : null
  let sExpires = ''

  if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
    return
  }

  if (expires) {
    switch (expires.constructor) {
      case Number:
        sExpires = expires === Infinity ?
          '; expires=Fri, 31 Dec 9999 23:59:59 GMT' :
          '; max-age=' + expires
        break
      case String:
        sExpires = '; expires=' + expires
        break
      case Date:
        sExpires = '; expires=' + expires.toUTCString()
        break
      default:
        sExpires = ''
    }
  }
  document.cookie =
    encodeURIComponent(key) + '=' + encodeURIComponent(value) + sExpires + (domain ? '; domain=' +
      domain : '') + (path ? '; path=' + path : '') + (isSecure ? '; secure' : '')
}

const setAndReturnSessionId = () =>{
  const sessionId = uuidv4()
  set(SESSION_NAME, sessionId, { domain: `.${DOMAIN}`, })
  return sessionId
}

const getSessionId = () => {
  const sessionId = get(SESSION_NAME)
  return sessionId ? sessionId : setAndReturnSessionId()
}

const buildHeaders = (headers?: Record<string, string>) => new Headers({
  'Trv-Session-Id': `${getSessionId()}`,
  'Trv-Correlation-Id': `${uuidv4()}`,
  'clientId': `${getClientId()}`,
  ...headers
})

export { buildHeaders }
